import React, { useState, useEffect } from "react";
import { Modal, Spin } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import BlogCard from "./BlogCard";
import styles from "./BlogList.module.css";
import Footer from "../../../components/Footer/Footer";
import Navbar from "../../../components/Navbar/Navbar";

const BlogList = ({ api }) => {
  const { accessToken } = useAuth();
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleAuthorClick = (pro_id) => {
    navigate(`/Realtors-and-Brokers/${pro_id}`);
  };

  useEffect(() => {
    // console.log("bloglist called!");
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(api, {
          headers: {
            // Authorization: `Bearer ${accessToken}`,
          },
        });
        if (response.status === 200 && response.data.success) {
          setBlogs(response.data.blogs);
          // console.log("Professional Blogs", response.data.blogs);
        } else {
          console.error("Failed to fetch blogs");
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, [accessToken]);

  const handleOpenModal = (blog) => {
    setSelectedBlog(blog);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBlog(null);
  };

  return (
    <>
      <Navbar />
      <section className={styles.blogList}>
        <h1 className={styles.header}>Latest Articles</h1>
        {loading ? (
          <Spin size="large" />
        ) : (
          <div className={styles.blogItems}>
            {blogs.map((blog) => (
              <BlogCard key={blog.id} blog={blog} onClick={handleOpenModal} />
            ))}
          </div>
        )}

        {/* Blog Modal */}
        <Modal
          visible={isModalOpen}
          onCancel={handleCloseModal}
          footer={null}
          width={800}
          className={styles.modal}
          bodyStyle={{
            padding: "20px",
            backgroundColor: "#f7f9fc",
            borderRadius: "8px",
          }}
        >
          {selectedBlog && (
            <div className={styles.blogDetail}>
              {selectedBlog.image_url && (
                <img
                  src={selectedBlog.image_url}
                  alt={selectedBlog.title}
                  className={styles.modalImage}
                />
              )}
              <h1 className={styles.modalTitle}>{selectedBlog.title}</h1>
              <div className={styles.modalInfo}>
                <p
                  className={styles.modalAuthor}
                  onClick={() => handleAuthorClick(selectedBlog?.pro_id)}
                >
                  By {selectedBlog.pro_first_name} {selectedBlog.pro_last_name}
                </p>
                <p className={styles.modalDate}>
                  {new Date(selectedBlog.created_at).toLocaleDateString()}
                </p>
              </div>
              <div
                className={styles.modalContent}
                dangerouslySetInnerHTML={{ __html: selectedBlog.description }}
              />
            </div>
          )}
        </Modal>
      </section>
      <Footer />
    </>
  );
};

export default BlogList;
